// extracted by mini-css-extract-plugin
export default {"root":"card_root__+65pd","cardImg":"card_cardImg__Mh9B9","detail":"card_detail__8R3ZB","rating":"card_rating__e7HKC","desc":"card_desc__I0yLR","button":"card_button__0Bp1w"};